import SearchParams from "../../init/searchparams";
import { isString, isPlainObject, withProperties, getValueAtPath, appendToArray, removeFromArray } from "../../utils";

function getResponseData(response) {
  try {
    const data = response.data;
    return ('response_parsed' in data) ? data.response_parsed : data;
  } catch (e) { return null }
}

function getChargeResponseError(data) {
  const {
    vbvrespmessage: v,
    acctvalrespmsg: a,
    chargeResponseMessage: c,
    response_message: m
  } = traverseDataFields(data, "vbvrespmessage", "acctvalrespmsg", "chargeResponseMessage", "response_message");

  return (
    (v && String(v).toUpperCase() !== "N/A" && (!String(v).startsWith('*') && !String(v).endsWith('#')) && v) ||
    (a && String(a).toUpperCase() !== "N/A" && a) ||
    (c && String(c).toUpperCase() !== "N/A" && c) ||
    (m && m.trim()) ||
    null
  );
}

function getChargeResponseCode(data) {
  const { chargeResponseCode, response_code, code } =
    traverseDataFields(data, 'chargeResponseCode', 'response_code', 'code');
  return chargeResponseCode || response_code || code || null;
}

function getChargeRedirectUrl(data) {
  const { auth_url, authurl, redirect_url, link } = traverseDataFields(data, 'auth_url', 'authurl', 'redirect_url', 'link');
  return auth_url || authurl || redirect_url || link || null;
}

function getChargeReference(data) {
  const { flwRef, flw_reference } = traverseDataFields(data, 'flwRef', 'flw_reference');
  return flwRef || flw_reference || null;
}

function getOrderReference(data) {
  const { orderRef, transaction_reference } = traverseDataFields(data, 'orderRef', 'transaction_reference');
  return orderRef || transaction_reference || null;
}

function getTransactionReference(data) {
  const { txRef } = traverseDataFields(data, 'txRef');
  return txRef || SearchParams.get('txref') || null;
}

function traverseDataFields(data, ...fields) {
  const dataLookupPriorityList = ['data', 'tx', 'err_tx', 'transactionobject'];

  traverseDataFields = function traverseDataFields(data, ...fields) {
    fields = fields.reduce((fields, field) => {
      isString(field) && (fields = appendToArray(fields, field));
      return fields;
    }, []);

    const resultsObject = Object.create(null);

    while (isPlainObject(data) && fields.length) {
      for (const field of fields) {
        const [dataField, exportField] = field.split('::');
        const value = getValueAtPath(data, dataField);

        if (value) {
          const _field = exportField || dataField;
          // withProperties(resultsObject, { [_field]: value });
          // fields = removeFromArray(fields, field);

          Object.prototype.hasOwnProperty.call(resultsObject, _field)
            ? (resultsObject[_field] = value)
            : withProperties(resultsObject, { [_field]: value }, true);
        }
      }

      for (const field of dataLookupPriorityList) {
        data = getValueAtPath(data, field);
        if (isPlainObject(data)) break;
      }
    }

    return resultsObject;
  }

  return traverseDataFields(data, ...fields);
}

export {
  getChargeRedirectUrl,
  getChargeReference,
  getChargeResponseCode,
  getChargeResponseError,
  getOrderReference,
  getResponseData,
  getTransactionReference,
  traverseDataFields
}
